import React, {useEffect, useState} from 'react';

import CanvasJSChart from "./CanvasJSChart";
import SpinnerDiv from "root/Components/SpinnerDiv";
import {getDataFromResponse, getNumRowsFromResponse} from "root/DataFunctions/BaseDataFns";
import {getChildDiaryEntries} from "root/DataFunctions/DashboardDataFns";
import {dashboardDefaults, defaultTitleFontSize} from "root/dashboard/DashboardDefault";

const DashboardPanelChildDiary = (props) =>
{
	const [ data, setData ] = useState ({ loading: true, data: []}) ;

	useEffect(() =>
	{
		getServerData() ;
	}, [props.month]);

    const generateDataPoints = ( items ) =>
	{
		return items.map ((item) =>
			{
				return ({
					label: item.class,
					y: Number(item.count),
					tool: item.count
				})
			}
		)
	}

	const getServerData = () => {

		getChildDiaryEntries( props.child_uid,  props.month, props.year,(response) =>
		{
			const recs = getDataFromResponse(response);

			setData ( { loading: false, data : recs}) ;
		});
	};

	const formPanel = () =>
	{
		const options = {
			maintainAspectRatio: false,
			responsive: true,
			animationEnabled: true,
			height: props.height,
			...dashboardDefaults,
			title: {
				text: props.title,
				fontSize: defaultTitleFontSize
			},
			data: [
				{
					type: 'column',
					lineColor: 'red',
					indexLabelPlacement: 'inside',    //Try Changing to outside
					showInLegend: true,
					legendMarkerColor: 'grey',
					legendText: 'Number of Diary Entries',
					toolTipContent: '{tool}',
					dataPoints: generateDataPoints(data.data)
				}
			] } ;

		return (
			<div className={'panel ' + props.panelStyle}>
				{ /* getPanelHeader({ title: props.title }) */}
				<div className='panel-body'>
					<CanvasJSChart id='chartChildAge' options={options} uniqueId='chartChildAge' />
				</div>
			</div>
		)
	}

	return data.loading === true ? <SpinnerDiv/> : formPanel() ;
}

export default DashboardPanelChildDiary;

DashboardPanelChildDiary.defaultProps =
{
	title: 'title',
	height: 500,
	panelStyle: 'panel-default',
}